import React, { PureComponent } from 'react';
import { Form, Card, Table, Button, Select, Tabs, Radio, Input, message, Menu, Dropdown } from 'antd';
import moment from 'moment'
import './eleCall.scss';
import { editExamRoom, getWaitExamData, suspensionTreatment, updateCall, passCallNumber, sequentialCall, arrivedCheck, checkComplete, examRoomList } from '@/request/api'

const { TabPane } = Tabs;
const { SubMenu } = Menu;


class EleCall extends PureComponent {
  constructor() {
    super()
    this.state = {
      tableData: [],
      isShow: true,
      arr: [],
      rowId: "",
      selectedType: 0,
      radioType: 2,
      room: "691",
    }
  }

  callColumns = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      width: 70,
      render: (text, record, index) => `${index + 1}`,
    },
    {
      title: '优先级别',
      dataIndex: 'CROWD_TYPE',
      key: 'CROWD_TYPE',
      width: 120
    },
    {
      title: '姓名',
      dataIndex: 'NAME',
      key: 'NAME',
      width: 90
    },
    {
      title: '性别',
      dataIndex: 'SEX',
      key: 'SEX',
      width: 90
    },
    {
      title: '来源',
      dataIndex: 'PATIENT_SOURCE',
      key: 'PATIENT_SOURCE',
      width: 90,
      render: source => <span>{source === "0" ? '门诊' :
        (source === "1" ? '住院' :
          (source === "2" ? '体检' :
            (source === "3" ? '急诊' : '')))}</span>,
    },
    {
      title: '费别',
      dataIndex: 'CHARGE_TYPE',
      key: 'CHARGE_TYPE',
      width: 90,
      render: costType => <span>{costType === "QT" ? '其他' :
        (costType === "ZF" ? '自费' :
          (costType === "GF" ? '公费' :
            (costType === "YB" ? '医保' :
              (costType === "部分自费" ? '部分自费' : ''))))}</span>,
    },
    {
      title: '呼叫房间',
      dataIndex: 'EXAM_ROOM',
      key: 'EXAM_ROOM',
      width: 120,
      render: (text, record, index) => {
        return <Dropdown overlay={() => this.menu(record)} trigger={['contextMenu']}>
          <span>{text}</span>
        </Dropdown>
      }
    },
    {
      title: '呼叫状态',
      dataIndex: 'CALLOK',
      key: 'CALLOK',
      width: 120,
      render: callType => <span>{callType === 0 ? '等待' :
        (callType === 1 ? '正在呼叫' :
          (callType === 2 ? '呼叫完成' :
            (callType === 3 ? '正在检查' :
              (callType === 4 ? '检查完成' :
                (callType === -1 ? '已过号' : '')))))}</span>,
    },
    {
      title: '计费',
      dataIndex: 'CHARGES',
      key: 'CHARGES',
      width: 90
    },
    {
      title: '预约时间',
      dataIndex: 'APPOINTMENT_TIME',
      key: 'APPOINTMENT_TIME',
      width: 170,
      render: (val) => (
        <span>
          { val && moment(val).format("YYYY-MM-DD HH:mm:ss")}
        </span>
      ),
    },
    {
      title: '登记时间',
      dataIndex: 'REGISTRATION_TIME',
      key: 'REGISTRATION_TIME',
      width: 170,
      render: (val) => (
        <span>
          { val && moment(val).format("YYYY-MM-DD HH:mm:ss")}
        </span>
      ),
    },
  ];

  componentDidMount() {
    this.handleGrop()
    //ES6解构赋值
    const { selectedType, radioType } = this.state
    this.props.form.setFieldsValue({ "time": selectedType, "time_slot": radioType }); //第一次进页面设置Radio的默认选中项为今天
  }

  menu(record) {
    let arr = JSON.parse(localStorage.getItem('roomList'))
    return <Menu>
      <SubMenu title="切换检查房间">
        {arr.map((item, index) => {
          return <Menu.Item key={index} onClick={() => this.handleClickRoom(record, item)}>{item.ROOM_NAME}</Menu.Item>
        })}
      </SubMenu>
    </Menu>
  }

  handleClickRoom(record, item) { //右键切换检查房间
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    if (record.EXAM_ROOM !== item.ROOM_NAME) {
      let params = {
        Type: "EDITEXAM_ROOM",
        HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
        EXAM_ROOM: item.ROOM_NAME,
        EXAM_UID: record.EXAM_UID
      }
      editExamRoom(params).then((res) => {
        if (res && res.Status === 1) {
          message.success("检查房间切换成功!")
          this.handleActiveKey()
        } else {
          message.error("检查房间切换失败!")
        }
      });
    } else {
      message.error("不能切换当前检查房间！")
    }
  }

  handleActiveKey = (type) => {  // 待检测列表  
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.setState({ defaultKey: type })
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let params = {
          Type: type || "WaitExamData",
          HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
          EXAM_ROOM: this.state.room,          // 检查房间
          ExamDate: this.state.selectedType,   // 检查日期 （今天、明天、后天、昨天）
          ExamTime: this.state.radioType  // 时间段 （上午、下午、全天）
        }
        getWaitExamData(params).then((res) => {
          if (res && res.Status === 1) {
            const dataOne = res.Result;
            this.setState({
              tableData: dataOne,
            })
          }
        });
      }
    })
  }

  radioChange = async (e) => {
    const { defaultKey } = this.state
    await this.setState({
      selectedType: e.target.value,
    })
    this.handleActiveKey(defaultKey)
  }

  radioTypeChange = async (e) => {
    const { defaultKey } = this.state
    await this.setState({
      radioType: e.target.value,
    })
    this.handleActiveKey(defaultKey)
  }

  handleSelectRoom = async (e, option) => {
    const { defaultKey } = this.state
    await this.setState({
      room: option.props.children,
    })
    this.handleActiveKey(defaultKey)
  }

  handleUpdate = () => {
    const { defaultKey } = this.state
    this.handleActiveKey(defaultKey)
  }

  onClickRow = (record) => {
    return {
      onClick: () => {
        this.setState({
          rowId: record
        });
      },
    };
  }

  setRowClassName = (record) => { // 暂停就诊
    return record === this.state.rowId ? 'clickRowStyl' : '';
  }

  handleShow = () => {  //暂停就诊
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let params = {
      Type: "stopWork",
      hospital_Code: userInfo.HOSPITAL_CODE,
      EXAM_ROOM: this.state.room,
      WORK_STATE: this.state.isShow
    }
    suspensionTreatment(params).then((res) => {
      if (res && res.Status === 1) {
        if (this.state.isShow === true) {
          this.setState({ isShow: false })
          message.success("已暂停就诊!")
        } else {
          this.setState({ isShow: true })
          message.success("已恢复就诊!")
        }
      } else {
        message.error("暂停就诊失败!")
      }
    });
  }

  callWebSocket = (id) => {
    const { defaultKey } = this.state
    // 打开一个 web socket
    var ws = new WebSocket("ws://39.98.68.80:3111");
    ws.onopen = () => {
      // Web Socket 已连接上，使用 send() 方法发送数据
      ws.send(id);
    };
    ws.onmessage = (evt) => {
      var callData = evt.data;
      console.log(callData, 'callData')
      if (callData === '呼叫完成') {
        this.handleActiveKey(defaultKey)
      }
    }
  }

  handleCall = () => {  // 呼叫患者 
    const { rowId, defaultKey } = this.state
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    if (rowId.CALLOK === 1 || rowId.CALLOK === 3 || rowId.CALLOK === 4) {
      message.error("当前状态不允许呼叫！")
    } else {
      let params = {
        Type: "UPDATECALL",
        HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
        EXAM_UID: rowId.EXAM_UID,
        CALLOK: 1
      }
      updateCall(params).then((res) => {
        if (res && res.Status === 1) {
          this.setState({ isShow: true })
          this.callWebSocket(rowId.EXAM_UID)
          message.success("呼叫成功!")
          this.handleActiveKey(defaultKey)
        } else {
          message.error("呼叫失败!")
        }
      });
    }
  }

  handleCrossNum = () => {  // 过号
    const { rowId, defaultKey } = this.state
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    if (rowId.CALLOK === 2) {
      let params = {
        Type: "CALLED",
        HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
        EXAM_UID: rowId.EXAM_UID,
        CALLOK: -1
      }
      passCallNumber(params).then((res) => {
        if (res && res.Status === 1) {
          message.success("过号成功!")
          this.handleActiveKey(defaultKey)
        } else {
          message.error("过号失败!")
        }
      });
    } else {
      message.error("当前状态不允许过号!")
    }
  }

  handleAlongCall = () => {  // 顺呼
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let params = {
          Type: "SEQUENTIALCALL",
          HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
          EXAM_ROOM: this.state.room,          // 检查房间
        }
        sequentialCall(params).then((res) => {
          if (res && res.Status === 1) {
            switch (res.ResponseModel.status) {
              case 0:
                message.success("顺呼成功!")
                break;
              case 1:
                message.warning("检查完成，暂时没有待呼叫的人")
                break;
              case 2:
                message.warning("呼叫成功，暂时没有正在检查的人")
                break;
              case 3:
                message.warning("暂时没有正在检查和待呼叫的人")
                break;
              default:
                break;
            }
            this.callWebSocket(res.ResponseModel.exam_uid)
          } else {
            message.error("顺呼失败!")
          }
        });
      }
    })
  }

  handleArrived = () => {  // 已到检
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    const { inputValue, defaultKey, rowId } = this.state
    if (rowId.CALLOK === 2 || inputValue !== "") {
      let params = {
        Type: "ARRIVEDCHECK",
        HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
        EXAM_UID: inputValue || rowId.EXAM_UID,
        CALLOK: 3
      }
      arrivedCheck(params).then((res) => {
        if (res && res.Status === 1) {
          message.success("到检成功!")
          this.handleActiveKey(defaultKey)
        } else {
          message.error("到检失败!")
        }
      });
    } else {
      message.error("只有呼叫完成才可以已到检!")
    }
  }

  handleComplete = () => { // 检查完成
    const { rowId } = this.state
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    if (rowId.CALLOK === 3) {
      let params = {
        Type: "CHECKCOMPLETE",
        HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
        EXAM_UID: rowId.EXAM_UID,
        CALLOK: 4
      }
      checkComplete(params).then((res) => {
        if (res && res.Status === 1) {
          message.success("检查成功!")
          this.handleActiveKey()
        } else {
          message.error("检查失败!")
        }
      });
    } else {
      message.error("当前状态不允许检查完成!")
    }
  }

  hnadleChangeValue = (e) => {
    this.setState({
      inputValue: e.target.value
    })
  }

  handleGrop = () => {  // 检查房间列表
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let params = {
      Type: "ExamData",
      hospital_uid: userInfo.HOSPITAL_UID,
    }
    examRoomList(params).then((res) => {
      if (res && res.Status === 1) {
        let data = res.Result
        localStorage.setItem('roomList', JSON.stringify(data))
        this.setState({ arr: data })
      } else {
        message.error("请检查网络连接")
      }
    });
  }

  getEleList(data, info) {
    const { selectedType, radioType, room, isShow, arr } = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <div>
        <div className="eleBox">
          <Form layout="inline" className="eleForm" >
            <Form.Item>
              {getFieldDecorator('time', {
                initialValue: selectedType
              })(
                <Radio.Group onChange={this.radioChange}>
                  <Radio value={0}>今天</Radio>
                  <Radio value={1}>明天</Radio>
                  <Radio value={2}>后天</Radio>
                  <Radio value={3}>昨天</Radio>
                </Radio.Group>
              )}
            </Form.Item>
            <Form.Item label="时间段">
              {getFieldDecorator('time_slot', {
                initialValue: radioType
              })(
                <Radio.Group onChange={this.radioTypeChange} >
                  <Radio value={0}>上午</Radio>
                  <Radio value={1}>下午</Radio>
                  <Radio value={2}>全天</Radio>
                </Radio.Group>
              )}
            </Form.Item>
            <Form.Item label="检查房间">
              {getFieldDecorator('check_room', {
                initialValue: room
              })(
                <Select placeholder="请选择检查房间" onChange={this.handleSelectRoom} style={{ width: "140px" }}>
                  {arr.map((item) => (
                    <Select.Option key={item.ROOM_CODE} value={item.ROOM_CODE}>
                      {item.ROOM_NAME}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Form>
          <div className="eleBtn">
            <Button onClick={this.handleShow}>{isShow === true ? "暂停就诊" : "恢复就诊"}</Button>
            {/* <Button>清除</Button> */}
            <Button onClick={this.handleCrossNum}>过号</Button>
            <Button onClick={this.handleCall}>呼叫</Button>
            <Button onClick={this.handleUpdate}>刷新</Button>
            <Button onClick={this.handleAlongCall}>顺呼</Button>
          </div>
        </div>

        <div style={{ padding: '20px 0' }}>
          <Table
            columns={this.callColumns}
            dataSource={data}
            rowKey={record => record.EXAM_UID}					// 需要修改为唯一的ID！
            scroll={{ x: 380, y: 380, scrollToFirstRowOnChange: true }}
            pagination={{
              showTotal: (count) => {
                let pageNum = Math.ceil(count / 8);
                return '共' + pageNum + '页 / ' + count + '条数据';
              }
            }}
            onRow={this.onClickRow}
            rowClassName={this.setRowClassName}
          />
          <p>{info}：{data && data.length}人</p>
        </div>
      </div >
    )
  }

  render() {
    const { tableData, inputValue } = this.state
    return (
      <div>
        <Tabs defaultActiveKey="1" type="card" tabBarGutter={0} className="tabWrap eleWrap" onChange={this.handleActiveKey}>
          <TabPane tab="待检查列表" key="WaitExamData">
            {this.getEleList(tableData, "待检查人数")}
          </TabPane>
          <TabPane tab="已检查列表" key="CheckedData">
            {this.getEleList(tableData, "已检查人数")}
          </TabPane>
          <TabPane tab="已过号列表" key="MissCallData">
            {this.getEleList(tableData, "已过号人数")}
          </TabPane>
          <TabPane tab="已呼叫未到检" key="Called_NotCheckedData">
            {this.getEleList(tableData, "已呼叫未到检人数")}
          </TabPane>
        </Tabs>

        <Card className="checkOne" title="检查唯一标识" size="small" style={{ padding: '20px 0' }}>
          <Input style={{ width: '30%' }} value={inputValue} onChange={this.hnadleChangeValue} />
          <Button style={{ marginLeft: '20px', color: '#fff' }} onClick={this.handleArrived}>已到检</Button>
          <Button style={{ float: 'right', color: '#fff' }} onClick={this.handleComplete}>检查完成</Button>
        </Card>
      </div>
    );
  }
}

export default (Form.create({})(EleCall));